// extracted by mini-css-extract-plugin
module.exports = {"detail":"_927a99ad28--detail--KYC4k","title":"_927a99ad28--title--IobrX","content":"_927a99ad28--content--J87UQ"};